export class invitationAdd {
  static readonly type = '[addInvitation] add';
  constructor(public inviteData: any) {}
}

export class invitationRemove {
  static readonly type = '[removeInvitation] remove';
}
